import { render } from "./ReferenceAdd.vue?vue&type=template&id=88f12f4a"
import script from "./ReferenceAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/reference/ReferenceAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "88f12f4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('88f12f4a', __exports__)) {
    api.reload('88f12f4a', __exports__)
  }
  
  module.hot.accept("./ReferenceAdd.vue?vue&type=template&id=88f12f4a", () => {
    api.rerender('88f12f4a', render)
  })

}


export default __exports__